import user from '@/core/legacy-auth/users'

export default {
  get legacyViewDisabled() { return user.type.BUYER && !user.entity.ENTERPRISE }
}



// WEBPACK FOOTER //
// ./src/core/feature-flags/feature-flags.js